import { ApolloClient, Reference, StoreObject } from '@apollo/client';

export const removeBusinessNotificationFromCache = (
  profileId: string | undefined,
  notificationId: string,
  client: ApolloClient<object>
) => {
  if (!profileId) return;

  const cacheId = client.cache.identify({
    __typename: 'CompanyProfile',
    id: profileId
  });

  if (!cacheId) return;

  client.cache.modify({
    id: cacheId,
    fields: {
      businessNotifications(existingNotifications = [], helpers) {
        return existingNotifications.filter(
          (notification: Reference | StoreObject) =>
            helpers.readField('id', notification) !== notificationId
        );
      }
    },
    broadcast: true
  });
};
